import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.GOOGLE_API}${path}`;

export default {
  /**
   * Fetch public Google Sheet data
   * @param {Object} opts
   * @param {String} opts.url - Public URL of the sheet
   * @param {String} opts.sheet - Name of the sheet tab
   * @param {String} opts.key - Unique id for namespacing
   * @returns {Promise<Object>} Sheet data response
   */
  async fetchPublicSheetData(opts = {}) {
    const { url, sheet, key } = opts;

    const query = {
      key,
      sheet,
      url,
    };

    const queryString = Object.keys(query)
      .filter((k) => query[k])
      .map((k) => `${k}=${encodeURIComponent(query[k])}`)
      .join('&');

    const resp = await fetch(`${getUrl('/sheets/url')}?${queryString}`, {
      mode: 'cors',
      credentials: 'include',
    });

    return resp;
  },

  /**
   * Fetch private Google Sheet data
   * @param {Object} opts
   * @param {String} opts.accountId - ID of google account that owns the workbook
   * @param {String} opts.workbookId - ID of the workbook
   * @param {String} opts.sheetId - ID of the sheet tab
   * @param {Boolean} opts.cache - Whether to use cached data (default: true)
   * @returns {Promise<Object>} Sheet data response
   */
  async fetchPrivateSheetData(opts = {}) {
    const {
      accountId,
      workbookId,
      sheetId,
      cache = true,
    } = opts;

    const queryString = cache ? '' : '?cache=false';

    const resp = await fetch(
      `${getUrl(`/sheets/${accountId}/${workbookId}/${sheetId}`)}${queryString}`,
      {
        mode: 'cors',
        credentials: 'include',
      }
    );

    return resp;
  },
};
